import { render, staticRenderFns } from "./CommentsSection.vue?vue&type=template&id=3c719a5b&scoped=true"
import script from "./CommentsSection.vue?vue&type=script&lang=js"
export * from "./CommentsSection.vue?vue&type=script&lang=js"
import style0 from "./CommentsSection.vue?vue&type=style&index=0&id=3c719a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c719a5b",
  null
  
)

export default component.exports